import { planTypes } from "@/common/constants";
import { PBX_SUB_TYPES } from "@/common/service/computers/plans/pbx";
import { pageConfig, flowTypes } from "@/common/service/page-config";
import { PBX_REGIONS } from "@/plans/ZOOM_PHONE/helper/constants";
import { isEmptyVal } from "@/utils";

export const AdditionalConfigTypeEnums = {
  // For NN or Free account buy pro plus plan. user can only config Phone Number in Additional Card.
  PN_ONLY: 'pn_only',
  // For paid account add or edit pro plus plan. user can config Phone Number and Toll-free Number in Additional Card.
  PN_AND_TF: 'pn_and_tf',
  // for Other flow, user can config additional number in zoom phone card.
  NONE: 'none'
};

/**
 * 
 * @param {*} pageConfig 
 * @returns {{ configType: string, region: string, supportAdditionalSubTypes: Array<string>}}
 */
export function getAdditionalConfigType(pageConfig = {}) {
  if (
    ![flowTypes.add2cart, flowTypes.edit, flowTypes.basic2pro, flowTypes.buyNow].includes(pageConfig.type) ||
    pageConfig.editConfig.planType !== planTypes.ZONE_PRO_PLUS ||
    !isEmptyVal(pageConfig.marketingCoupon)
  ) {
    return {
      configType: AdditionalConfigTypeEnums.NONE,
      region: PBX_REGIONS.US_AND_CANADA,
      supportAdditionalSubTypes: []
    }
  }

  if ([flowTypes.add2cart, flowTypes.edit].includes(pageConfig.type)) {
    return {
      configType: AdditionalConfigTypeEnums.PN_AND_TF,
      region: PBX_REGIONS.US_AND_CANADA,
      supportAdditionalSubTypes: [PBX_SUB_TYPES.PHONE_NUMBER, PBX_SUB_TYPES.TOLLFREE],
    }
  }

  return {
    configType: AdditionalConfigTypeEnums.PN_ONLY,
    region: PBX_REGIONS.US_AND_CANADA,
    supportAdditionalSubTypes: [PBX_SUB_TYPES.PHONE_NUMBER],
  }
}

export const additionalConfigType = getAdditionalConfigType(pageConfig);
